import React, { FC } from "react";
import { Link } from "react-router-dom";
import twFocusClass from "utils/twFocusClass";
import { useLocation } from "react-router-dom";

export interface PaginationProps {
  className?: string;
  current?: number;
  length?: number;
}

const Pagination: FC<PaginationProps> = ({
  className = "",
  current = 0,
  length = 1,
}) => {
  const searchQuery = new URLSearchParams(useLocation().search);
  let obj: string[] = [];

  for (var key of searchQuery.keys()) {
    if (key !== "page") obj.push(`${key}=${searchQuery.get(key)}`);
  }
  const pages = Math.ceil((length as number) / 8);

  const newArray = Array.apply(null, Array(pages)).map((value, index) => {
    return index;
  });

  const renderItem = (index: number) => {
    //eslint-disable-next-line
    if (index == current) {
      // RETURN ACTIVE PAGINATION
      return (
        <span
          key={index}
          className={`inline-flex w-11 h-11 items-center justify-center rounded-full bg-primary-6000 dark:bg-primary-6000 text-white ${twFocusClass()}`}
        >
          {index + 1}
        </span>
      );
    }

    if (
      index === 0 ||
      index === current - 1 ||
      index === current + 1 ||
      index === pages - 1
    ) {
      // RETURN UNACTIVE PAGINATION
      return (
        <Link
          key={index}
          className={`inline-flex w-11 h-11 items-center justify-center rounded-full bg-white hover:bg-neutral-100 border border-neutral-200 text-neutral-6000 dark:text-neutral-400 dark:bg-neutral-900 dark:hover:bg-neutral-800 dark:border-neutral-700 ${twFocusClass()}`}
          to={`listing?${obj.join("&")}&page=${index}`}
        >
          {index + 1}
        </Link>
      );
    }

    if (index === current + 2 || index === current - 2) {
      return <span>...</span>;
    }
  };

  return (
    <nav
      className={`nc-Pagination flex items-end space-x-1 text-base font-medium ${className}`}
    >
      {newArray.map(renderItem)}
    </nav>
  );
};

export default Pagination;
